var file_upload_viewer_default = {
  "fontElementMap": "_5UN6w",
  "file_upload_container": "Srvo0",
  "file_upload_link": "Q-uZq",
  "file_upload_error_container": "uWTQu",
  "file_upload_file_info": "-uv69",
  "file_upload_type_icon": "k2Jse",
  "file_upload_status_icon_container": "G2d5z",
  "file_upload_status_icon": "C0Qp5",
  "file_upload_description": "-NE7I",
  "file_upload_name_container": "eDbrg",
  "file_upload_name": "DmmsI",
  "file_upload_extension": "_9u-MV",
  "file_loader_icon": "gtTe5",
  "file_upload_icon_frame": "nOuWY",
  "file_upload_icon_background": "RWjKr"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
